// extracted by mini-css-extract-plugin
export default {"Section":"Cabinet_Section__AYkEd","leftSide":"Cabinet_leftSide__Vmf6Z","rightSide":"Cabinet_rightSide__Sy8DD"};